// stores/base-store.js
// SIMPLIFIED - removed complex caching, batching, and optimistic updates
import { writable, get } from 'svelte/store';

export function createBaseStore(options = {}) {
  const { subscribe, set, update } = writable({
    items: [],
    loading: false,
    error: null,
    selected: null
  });

  return {
    subscribe,

    async load(filters = {}, forceRefresh = false) {
      update(state => ({ ...state, loading: true, error: null }));

      try {
        const data = await options.loadFn(filters);
        update(state => ({
          ...state,
          items: Array.isArray(data) ? data : [],
          loading: false,
          error: null
        }));
        return data;
      } catch (error) {
        update(state => ({
          ...state,
          error: error.message || 'Failed to load',
          loading: false
        }));
        throw error;
      }
    },

    async add(data) {
      update(state => ({ ...state, loading: true, error: null }));

      try {
        const result = await options.addFn(data);
        update(state => ({
          ...state,
          items: [...state.items, result],
          loading: false
        }));
        return result;
      } catch (error) {
        update(state => ({
          ...state,
          error: error.message || 'Failed to add',
          loading: false
        }));
        throw error;
      }
    },

    async update(id, data) {
      update(state => ({ ...state, loading: true, error: null }));

      try {
        const result = await options.updateFn(id, data);
        update(state => ({
          ...state,
          items: state.items.map(item =>
            item.id === id ? { ...item, ...result } : item
          ),
          selected: state.selected?.id === id ? { ...state.selected, ...result } : state.selected,
          loading: false
        }));
        return result;
      } catch (error) {
        update(state => ({
          ...state,
          error: error.message || 'Failed to update',
          loading: false
        }));
        throw error;
      }
    },

    async delete(id) {
      update(state => ({ ...state, loading: true, error: null }));

      try {
        await options.deleteFn(id);
        update(state => ({
          ...state,
          items: state.items.filter(item => item.id !== id),
          selected: state.selected?.id === id ? null : state.selected,
          loading: false
        }));
      } catch (error) {
        update(state => ({
          ...state,
          error: error.message || 'Failed to delete',
          loading: false
        }));
        throw error;
      }
    },

    setSelected(id) {
      update(state => ({
        ...state,
        selected: state.items.find(item => item.id === id) || null
      }));
    },

    clearSelected() {
      update(state => ({ ...state, selected: null }));
    },

    clearError() {
      update(state => ({ ...state, error: null }));
    },

    getState() {
      return get({ subscribe });
    },

    reset() {
      set({
        items: [],
        loading: false,
        error: null,
        selected: null
      });
    }
  };
}
